import API from 'services/api';

export const getPropertyUnits = (propertyId: string | undefined) =>
  API.get(`/api/accommodation/properties/${propertyId}/units`).then(response => response?.data);
